module.exports = __webpack_public_path__ + "img/battletrip_main.66449fed.jpg";